import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const table = translations[lang]?.productPage?.bulk_upload_page?.table?.Col

export const BulkUploadColumns = [
  { label: table?.file_name || "FILE NAME", dataKey: "file_name" },
  { label: table?.date || "DATE", dataKey: "uploaded_at" },
  { label: table?.file_type || "FILE TYPE", dataKey: "file_extension" },
  { label: table?.status || "STATUS", dataKey: "file_status" },
]
